export const PADDING = 2 * 12;
export const MIN_HEIGHT = 72 + PADDING;
